import React, { useState, useEffect } from "react";
import CryptoJS from "crypto-js";
import Chip from "@mui/material/Chip";
import Box from "@mui/material/Box";
import MuiCard from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import CardContent from "@mui/material/CardContent";
import FormControl from "@mui/material/FormControl";
import RadioGroup from "@mui/material/RadioGroup";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";
import Skeleton from "../../../Kit/Skeleton/SkeletonCard";
import { useAuth } from "../../../Auth/AuthProtecter";

const dataSke = [
  {
    id: 1,
  },
  {
    id: 2,
  },
];

const LST = process.env.REACT_APP_API_FRRS_LSTOREGE;
const secretKey = process.env.REACT_APP_SECRET_KEY_LOCALSTORAGE;

const Card = styled(MuiCard)(({ theme }) => ({
  border: "1px solid",
  borderColor: (theme.vars || theme).palette.divider,
  width: "100%",
  "&:hover": {
    background:
      "linear-gradient(to bottom right, hsla(210, 100%, 97%, 0.5) 25%, hsla(210, 100%, 90%, 0.3) 100%)",
    borderColor: "primary.light",
    boxShadow: "0px 2px 8px hsla(0, 0%, 0%, 0.1)",
    ...theme.applyStyles("dark", {
      background:
        "linear-gradient(to right bottom, hsla(210, 100%, 12%, 0.2) 25%, hsla(210, 100%, 16%, 0.2) 100%)",
      borderColor: "primary.dark",
      boxShadow: "0px 1px 8px hsla(210, 100%, 25%, 0.5) ",
    }),
  },
  [theme.breakpoints.up("md")]: {
    flexGrow: 1,
    maxWidth: `calc(50% - ${theme.spacing(1)})`,
  },
  variants: [
    {
      props: ({ selected }) => selected,
      style: {
        borderColor: (theme.vars || theme).palette.primary.light,
        ...theme.applyStyles("dark", {
          borderColor: (theme.vars || theme).palette.primary.dark,
        }),
      },
    },
  ],
}));

const loct = process.env.REACT_APP_API_LOCATION;

export default function AppointmentRequestSucur({ ...other }) {
  //
  const auth = useAuth();
  //
  const [Url, setLoginUrl] = React.useState(auth.Domain);
  //
  const bytes = CryptoJS.AES.decrypt(sessionStorage.getItem(LST), secretKey);
  const stat = JSON.parse(bytes.toString(CryptoJS.enc.Utf8)).stat;
  const { id, name } = stat;
  //
  const [paymentType, setPaymentType] = useState("creditCard");
  const [OptLoc, setOptLoc] = useState(null);
  //
  const handlePaymentTypeChange = (event) => {
    setPaymentType(event.target.value);
  };

  const handleNext = (sucur) => {
    const loct = { stat };
    const state = { ...loct, sucur };

    sessionStorage.setItem(
      LST,
      CryptoJS.AES.encrypt(JSON.stringify(state), secretKey).toString()
    );
    other.setActiveStep(other.activeStep + 1);
  };

  useEffect(() => {
    const fetchResource = async () => {
      const datePost = {
        idstate: Number(id),
      };
      //
      try {
        //
        //
        const jsonpass = {
          method: "POST",
          body: JSON.stringify(datePost),
        };
        //
        const respass = await fetch(`${Url}${loct}`, jsonpass);
        //
        console.log(respass);

        const res_pass = await respass.json();
        //
        if (respass.status === 200) {
          setOptLoc(res_pass);
        } else {
          setOptLoc(null);
        }
        //
      } catch (error) {
        //
        setOptLoc(null);
        //
      }
    };
    fetchResource();
  }, []);
  //
  //
  //
  return (
    <Stack spacing={{ xs: 3, sm: 6 }} useFlexGap>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant="h6" gutterBottom>
          <Chip label={`🗺️ ${name}`} /> / Elija su sucursal más cercana
        </Typography>
      </Box>
      <FormControl component="fieldset" fullWidth>
        <RadioGroup
          aria-label="Payment options"
          name="paymentType"
          value={paymentType}
          onChange={handlePaymentTypeChange}
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            gap: 2,
          }}
        >
          {OptLoc
            ? OptLoc.map((label) => (
                <Card key={label.id}>
                  <CardActionArea
                    onClick={() => handleNext(label)}
                    sx={{
                      ".MuiCardActionArea-focusHighlight": {
                        backgroundColor: "transparent",
                      },
                      "&:focus-visible": {
                        backgroundColor: "action.hover",
                      },
                    }}
                  >
                    <CardContent
                      sx={{ display: "flex", alignItems: "center", gap: 1 }}
                    >
                      📍{" "}
                      <Typography sx={{ fontWeight: "medium" }}>
                        {label.name}{" "}
                      </Typography>
                    </CardContent>
                  </CardActionArea>
                </Card>
              ))
            : dataSke.map((da, i) => (
                <Card key={da.id}>
                  <Skeleton key={da.id} />
                </Card>
              ))}
        </RadioGroup>
      </FormControl>
    </Stack>
  );
}
